import { CustomTabPanel } from "@/erp/sale/component";
import { a11yProps, ModulosEnumChoice, sizeTab } from "@/shared";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { EstadoBitacoraEnum } from "@/shared/interfaces";
import { useDiccionarioMotivo } from "@/store/erp/diccionario_motivo/diccionario_motivo.store";
import TableBitacoraComponenteVenta from "../../componente/TableBitacoraComponenteVentas";

export default function BitacoraVentaPage() {
  const [valueTab, setValueTab] = useState(0)

  const setFaseVenta = useDiccionarioMotivo().setFaseVenta

  useEffect(() => {
    setFaseVenta(ModulosEnumChoice.BITACORA);
  }, [])


  return (
    <>
      <SingleTableBoxScene
        title={"Bitácora Venta"}
      >

        <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }}>
          <Tabs
            value={valueTab}
            onChange={(_event: React.SyntheticEvent, newValue: number) => {
              setValueTab(newValue)
            }}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="scrollable force tabs bitacora"
          >
            <Tab label={'En Espera'} {...a11yProps(0)} />
            <Tab label={'Historial'} {...a11yProps(1)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={valueTab} index={0}>
          <TableBitacoraComponenteVenta
            enable_action={false}
            estado_bitacora={EstadoBitacoraEnum.EN_PROCESO}
          />
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={1}>
          <TableBitacoraComponenteVenta
            enable_action={false}
            estado_bitacora={EstadoBitacoraEnum.FINALIZADO}
            disabledAction={true}
          />
        </CustomTabPanel>

      </SingleTableBoxScene>


    </>


  )

}